export default __webpack_public_path__ + "static/media/sports-cat.60c34497.webp";